import { TLCEvents } from "./events";

export class TLCEventManager {
  /**
   *
   * @param {string} handle
   * @param {*=} data
   * @deprecated
   */
  static fireEvent(handle, data) {
    TLCEvents.trigger(handle, data);
  }

  /**
   *
   * @param {string} handle
   * @param {Function} callback
   * @returns {number}
   * @deprecated
   */
  static addOneTimeListener(handle, callback) {
    return TLCEvents.once(handle, callback);
  }

  /**
   *
   * @param {string} handle
   * @param {Function} callback
   * @param {boolean=} isOneTime
   * @returns {number}
   * @deprecated
   */
  static addListener(handle, callback, isOneTime) {
    return TLCEvents.on(handle, callback, isOneTime);
  }

  /**
   *
   * @param {string} handle
   * @param {number} guid
   * @deprecated
   */
  static removeListener(handle, guid) {
    TLCEvents.off(handle, guid);
  }
}
